import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    console.log("Access Denied. User Role:", user.role, "Allowed:", allowedRoles);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}